import * as React from 'react';
import { AnalyticsTrigger, Button, IButtonProps } from 'telia-front-react';

export interface IButtonWithAnalyticsProps {
  gaEvent: string;
  buttonProps: IButtonProps;
}

export default class ButtonWithAnalytics extends React.Component<IButtonWithAnalyticsProps> {
  public render(): JSX.Element {
    return (
      <AnalyticsTrigger
        trigger={{
          callback: 'onClick',
          id: `${this.props.gaEvent}`
        }}
      >
        <Button {...this.props.buttonProps} />
      </AnalyticsTrigger>
    );
  }
}
